import { render, staticRenderFns } from "./markets.vue?vue&type=template&id=15a05bdc&scoped=true"
import script from "./markets.vue?vue&type=script&lang=js"
export * from "./markets.vue?vue&type=script&lang=js"
import style0 from "./markets.vue?vue&type=style&index=0&id=15a05bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a05bdc",
  null
  
)

export default component.exports